import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "profile",
  "use": "profile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"profile\"><rect x=\"3.75\" y=\"2.75\" width=\"16.5\" height=\"18.5\" rx=\"1.25\" stroke=\"#677078\" stroke-width=\"1.5\" /><path d=\"M12 12a2.5 2.5 0 10.001-4.999A2.5 2.5 0 0012 12zm0 1.25c-1.669 0-5 .838-5 2.5V17h10v-1.25c0-1.662-3.331-2.5-5-2.5zM22 4a1 1 0 011 1v14a1 1 0 01-1 1V4zM1 5a1 1 0 011-1v16a1 1 0 01-1-1V5z\" fill=\"#677078\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol